import * as actionTypes from 'modules/serviceHeaders/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = {};

const update = (state, { payload, meta = {} }) => {
  const { taskId } = meta;
  if (taskId) {
    const [entry] = payload;
    return {
      ...state,
      [taskId]: entry,
    };
  }
  return state;
};

export default createReducer(initialState, {
  [actionTypes.FETCH_SERVICE_HEADER_SUCCESS]: update,
});
